import { render } from "./OutstandingProperties.vue?vue&type=template&id=44c506e0&scoped=true"
import script from "./OutstandingProperties.vue?vue&type=script&lang=js"
export * from "./OutstandingProperties.vue?vue&type=script&lang=js"

import "./OutstandingProperties.vue?vue&type=style&index=0&id=44c506e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c506e0"]])

export default __exports__